import SalesChannelToolbar from "./SalesChannelToolbar";

export default SalesChannelToolbar;
